<template>
    <v-container fluid>
    <field-form  v-if="item && item.platform != 'SHOPIFY'" @save="save" ref="form" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" @cancel="cancelWizard()">
    <h2 class="text-h4">{{$t('feeds.title')}}</h2>
    
    <template #required>
    <v-text-field id="pfid1618853572" v-model="fields.productFeedURL" 
      style="max-width:800px"
      :label="$t('feeds.productFeed')"
      class="pr-3"
      :rules="[v => !!v || $t('form.rules.required'), v => isValidUrl(v) || $t('form.rules.url')]"
      />
    </template>
    
    <template #optional>
      <!--
      <v-text-field id="pfid1618853576" v-model="fields.orderFeedURL" 
      disabled
      style="max-width:800px"
      :label="$t('feeds.ordersFeed') + ' - ' + $t('common.comingSoon')" 
      class="pr-3"
      :rules="[ v => !v || isValidUrl(v) || $t('form.rules.url')]"
      />
      -->
      <v-text-field id="pfid1645181330"  v-model="fields.categoriesFeedURL" 
      style="max-width:800px"
      :label="$t('feeds.categoriesFeed')" 
      class="pr-3"
      :rules="[ v => !v || isValidUrl(v) || $t('form.rules.url')]"
      />
    </template>
    </field-form>
    <field-form  v-else-if="item && item.platform == 'SHOPIFY'" @save="save" ref="form" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" @cancel="cancelWizard()">
      <!-- SHOPIFY version - the if cannot be inside the netity form because it would nest slots -->
      <h2 class="text-h4">{{ $t('feeds.shopify.title') }}</h2>
      <template #required>
      <v-text-field id="pfid1647509992"  v-model="fields.productFeedURL" 
        style="max-width:400px"
        :label="$t('feeds.shopify.store')"
        suffix=".myshopify.com"
        class="pr-3"
        :rules="[v => !!v || $t('form.rules.required'), v => isValidShopifyStore(v) || $t('form.rules.shopifyStore')]"
      />
      <template v-if="shopifyPendingInstall">
      <v-btn class="mt-1" 
       :disabled="!fields.productFeedURL" type="submit" 
      @click="$refs.form.nwSave = true; redirectToShopify = true;" 
      color="success" :loading="saving || loading">
        <v-icon left>$add</v-icon>{{$t('feeds.shopify.install')}}</v-btn>
        <v-row no-gutters align="center" justify="start">
        <div>Already installed? Check the shop name in the field above and</div>
          <v-btn text type="submit" @click="$refs.form.nwSave = true;"><v-icon left>$refresh</v-icon>try again</v-btn><div>.</div>
        </v-row>
      </template>
      <v-alert v-else-if="fields.productFeedURL" type="success" colored-border border="left">
        {{ $t('feeds.shopify.connected') }}
      </v-alert>
    </template>
    </field-form>
    <v-skeleton-loader v-else type="card">
    </v-skeleton-loader>
    </v-container>
</template>
<script>
  import EntityForm from "@/mixins/entity-form"
  import Capabilities from "@/mixins/capabilities"
  import Wizards from "@/mixins/wizards"

  export default {
    name: 'Feeds',
    mixins: [Capabilities, EntityForm, Wizards],
    data() {
      return {
          endpoint: 'domains',
          help: false,
          fields: {
          productFeedURL: null,
          orderFeedURL: null,
          categoriesFeedURL: null
          },
          wizardParams: {
            platform: null
          },
          loading: false,
          redirectToShopify: false
      };
    },
    watch: {
      
    },
    computed: {
        shopifyPendingInstall() {
          if(!this.item) { return false; }
          return this.item.platform == 'SHOPIFY' && !this.item.shopifyStore;
        }
    },
    methods: {
        isValidShopifyStore(string) {
          return /[a-zA-Z0-9][a-zA-Z0-9-]*/.test(string);
        },
        afterFieldsLoad() {
          if(this.item.platform == 'SHOPIFY') {
            this.fields.productFeedURL = this.fields.productFeedURL?.replace('.myshopify.com', '');
          }
        },
        prepareFields(nowizard) {
          // prevents to continue if integration is not completed
          if(this.item.platform == 'SHOPIFY') {
            if(this.shopifyPendingInstall && !nowizard) {
              this.$store.dispatch('ui/notify', {text: this.$t('feeds.shopify.notLinked'), error: true });
              return false;
            }
            this.fields.productFeedURL = this.fields.productFeedURL ? `${this.fields.productFeedURL}.myshopify.com` : null;
          }
        },
        beforeSave(fields) {
            
            if(this.wizard) {
              this.wizardParams.platform = this.item.platform.toLowerCase();
            }
            // check capabilities and switch to ACTIVE if all conditions met
            fields.capabilities = Object.assign({}, this.item.capabilities);
            // this passed validation, feed URL is present
            fields.capabilities.feed = true;
            if(fields.orderFeedURL) {
                fields.capabilities.orders = true;
            }
            if(this.item.active == 'INCOMPLETE' && this.canActivate(fields.capabilities)) {
                fields.active = 'ACTIVE';
            }
            return fields;
        },
        afterSave() {
          // redirect to Shopify
          if(this.redirectToShopify) {
            window.location.assign(this.$store.getters['ui/shopifyUrl']);
          }

        },
    },
    created() {
      if(this.$route.query.shopify == 'verify') {
        // load wizard
        this.$store.commit('ui/wizard', {value: true});
      }
    }
  }
</script>